export default {
    methods: {
        formatMoney(value = 0, prefix = '') {
            let configs = _config.functionalities.digitalmenu.configs

            let options = configs.show_price_symbol ? {
                style: 'currency', currency: 'BRL'
            } : {};
            return prefix + new Intl.NumberFormat('pt-BR', {
                ...options,
                maximumFractionDigits: configs.show_decimal ? 2 : 0,
                minimumFractionDigits: configs.show_decimal ? 2 : 0
            }).format(value);
        }
    }
}